import {createStyles, Title} from '@mantine/core';
import React from 'react';

const useStyles = createStyles((theme) => ({
  header: {
    fontSize: theme.fontSizes.xs,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    color: theme.colors.gray[5],
    margin: '18px 0 6px 4px',
  },
}));

/**
 * Shared section heading for the redesigned sidebar, keeping Agents and chat-history sections
 * visually identical.
 */
export default function SidebarSectionHeader({children}: {children: React.ReactNode}): JSX.Element {
  const {classes} = useStyles();
  return (
    <Title order={2} className={classes.header}>
      {children}
    </Title>
  );
}
